import gql from 'graphql-tag';

export const LICENSES_BY_COMPANY_ID = gql`
  query GetCompanyLicenses($id: ID!) {
    Company(id: $id) {
      id
      licenses {
        id
        plan
        status
      }
    }
  }
`;
